import { Switch, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { toggleSnapToGridInRedux } from "../../designSlice";
import { HOTKEYS } from "../../../constants";

export const ActivateSnapSwitch: React.FC = () => {
  const snapToGrid = useAppSelector((state) => state.design.snapToGrid);

  const dispatch = useAppDispatch();
  return (
    <Tooltip
      label="Angi om produktet automatisk skal flyttes til nærmeste plate ved redigering"
      position="bottom"
    >
      <Switch
        checked={snapToGrid}
        onChange={() => dispatch(toggleSnapToGridInRedux())}
        label={`Aktiver snap`}
      />
    </Tooltip>
  );
};
